<template>
	<div class="user-center-container">
		<div class="user-center-content">
			<!-- 企业认证区域--start -->
			<div class="company-auth-container">
				<!-- 已认证企业信息展示 -->
				<div v-if="isHasCompanyAuth" class="company-info-section">
					<div class="section-header">
						<h3 class="section-title">企业认证信息</h3>
						<div class="auth-status" :class="getStatusClass(companyAuthInfo.auditState)">
							{{ getStatusText(companyAuthInfo.auditState) }}
						</div>
					</div>

					<div class="info-content">
						<div class="info-item">
							<span class="info-label">企业名称：</span>
							<span class="info-value">{{ companyAuthInfo.companyName }}</span>
						</div>
						<div class="info-item">
							<span class="info-label">企业社会信用代码：</span>
							<span class="info-value">{{ companyAuthInfo.companyCode }}</span>
						</div>
						<div class="info-item">
							<span class="info-label">认证时间：</span>
							<span class="info-value">{{ companyAuthInfo.createTime || '暂无' }}</span>
						</div>
						<div class="info-item">
							<span class="info-label">认证文件类型：</span>
							<span class="info-value">{{ getFileType(companyAuthInfo.fileType) }}</span>
						</div>

						<!-- 材料文件 -->
						<div class="file-preview-list">
							<div class="file-item">
								<div class="file-info">
									<i class="el-icon-document"></i>
									<span class="file-name">{{ companyAuthInfo.fileName }}</span>
								</div>
								<div class="file-actions">
									<el-button type="text" size="small" @click="previewFile(companyAuthInfo.id)">
										<i class="el-icon-view"></i>
										预览
									</el-button>
									<el-button type="text" size="small" @click="downloadFile(companyAuthInfo.id)">
										<i class="el-icon-download"></i>
										下载
									</el-button>
								</div>
							</div>
						</div>

						<div v-if="companyAuthInfo.auditState === '2'" class="info-item">
							<span class="info-label">审核原因：</span>
							<span class="info-value">{{ companyAuthInfo.remark || '' }}</span>
						</div>

						<div class="info-actions">
							<button v-if="companyAuthInfo.auditState === '2'" class="action-button primary" @click="handleReAuth">
								重新认证
							</button>
							<button v-if="companyAuthInfo.auditState === '1'" class="action-button" @click="handleUpdateAuth">解除绑定</button>
						</div>
					</div>
				</div>

				<!-- 企业认证输入区域 -->
				<div v-else class="auth-input-section">
					<div class="input-wrapper">
						<div class="search-dropdown">
							<input
								v-model="companyName"
								type="text"
								class="company-input"
								placeholder="请输入企业名称"
								@input="handleSearchInput"
								@focus="showDropdown = true"
								@blur="handleBlur"
							/>
							<div v-show="showDropdown && companyList.length > 0" class="dropdown-list" v-loading="loading">
								<div v-for="(item, index) in companyList" :key="index" class="dropdown-item" @mousedown="selectCompany(item)">
									<span v-html="highlightKeyword(item.companyName)"></span>
								</div>
								<div v-if="companyList.length === 0 && companyName" class="dropdown-empty">
									未找到相关企业
								</div>
							</div>
						</div>
					</div>
					<button class="auth-button" type="button" @click="handleConmpanyAuth">立即认证</button>
				</div>

				<!-- 常见问题区域 -->
				<div class="faq-section">
					<h2 class="moudleDefaultTitle">常见问题</h2>

					<div class="faq-content">
						<div class="faq-item">
							<h3 class="faq-question">谁可以申请认证?</h3>
							<div class="faq-answer">
								<p>1、认证企业为在中国大陆依法注册的企业。</p>
								<p>2、企业经营正常，未发生重大违法行为、未发生严重失信行为的企业</p>
								<p>3、非行业内重点黑名单被露企业</p>
							</div>
						</div>

						<div class="faq-item">
							<h3 class="faq-question">如果我的认证申请未通过，怎么办?</h3>
							<div class="faq-answer">
								<p>如果认证未通过，我们会提供详细的反馈意见。您可以根据反馈内容进行修改，并重新提交申请</p>
							</div>
						</div>

						<div class="faq-item">
							<h3 class="faq-question">认证是否有有效期?</h3>
							<div class="faq-answer">
								<p>是的，企业认证的有效期通常为一年。到期后，您可以更新申请以保持认证状态</p>
							</div>
						</div>

						<div class="faq-item">
							<h3 class="faq-question">认证完成后，如何维护企业信息?</h3>
							<div class="faq-answer">
								<p>您可以通过个人中心-我的企业随时更新和维护您的基础信息，确保企业资料的准确性和时效性。</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 企业认证区域--end -->
		</div>
	</div>
</template>

<script>
	import { companyInfoPageList, getUserLastAuthRecord, updateCompanyAuthStatus } from '@/api/userCenter/companyAuth'
	import { previewAuthFile, downloadAuthFile } from '@/api/userCenter/companyAuth.js'
	import { getToken } from '@/utils/auth'
	// 我的企业
	export default {
		name: 'UserCompany',
		components: {},
		props: {},
		data() {
			return {
				companyName: '',
				companyList: [], // 企业列表
				showDropdown: false, // 是否显示下拉框
				searchTimer: null, // 搜索防抖定时器
				/** 选中的企业 */
				selectedCompany: null, // 选中的企业
				// 已有企业认证信息
				isHasCompanyAuth: false,
				// 企业认证信息对象
				companyAuthInfo: {},
				loading: false
			}
		},
		computed: {},
		watch: {},
		created() {
			this.handleQueryMyCompanyAuthInfo()
		},
		mounted() {
			// 添加点击外部关闭下拉框
			document.addEventListener('click', this.handleOutsideClick)
		},
		beforeDestroy() {
			// 移除事件监听
			document.removeEventListener('click', this.handleOutsideClick)
		},
		methods: {
			// 认证文件类型
			getFileType(val) {
				if (val == 1) {
					return '营业执照'
				} else if (val == 2) {
					return '对公打款证明'
				} else if (val == 3) {
					return '在职证明'
				}
			},
			// 预览文件
			previewFile(id) {
				window.open(previewAuthFile({ InternetToken: getToken(), companyApplyAuthId: id }), '_blank')
			},

			// 下载文件
			downloadFile(id) {
				window.open(downloadAuthFile({ InternetToken: getToken(), companyApplyAuthId: id }), '_blank')
			},

			/**
			 * 查询我的企业认证信息
			 */
			handleQueryMyCompanyAuthInfo() {
				getUserLastAuthRecord().then(response => {
					console.log('查询我的企业认证信息', response)
					const { data } = response
					if (data) {
						// 如果data有值，代表该企业已有认证信息
						this.isHasCompanyAuth = true
						this.companyAuthInfo = data
						if (data.auditState === '4') {
							// 企业绑定关系为废止
							this.isHasCompanyAuth = false
						}
					} else {
						this.isHasCompanyAuth = false
						this.companyAuthInfo = {}
					}
				})
			},

			// 获取审核状态文本
			getStatusText(status) {
				const statusMap = {
					'0': '审核中',
					'1': '已认证',
					'2': '审核不通过',
					'3': '已过期'
				}
				return statusMap[status] || '未知状态'
			},

			// 获取审核状态样式类
			getStatusClass(status) {
				const classMap = {
					'0': 'status-pending',
					'1': 'status-success',
					'2': 'status-failed',
					'3': 'status-expired'
				}
				return classMap[status] || ''
			},

			// 重新认证
			handleReAuth() {
				this.$router.push({
					path: '/user/common/company/auth',
					query: {
						companyName: this.companyAuthInfo.companyName,
						companyCode: this.companyAuthInfo.companyCode
					}
				})
			},

			// 解除企业绑定
			handleUpdateAuth() {
				const params = {
					companyApplyAuthId: this.companyAuthInfo.id,
					// 废止
					auditState: '4'
				}

				this.$modal
					.confirm('是否解绑当前企业？')
					.then(function() {
						return updateCompanyAuthStatus(params)
					})
					.then(() => {
						this.$message.success('解除企业绑定成功')
						this.handleQueryMyCompanyAuthInfo()
						// 更新一下用户信息，更新企业绑定关系
						this.$store.dispatch('user/getUserInfo')
					})
					.catch(() => {})
			},

			// 处理输入搜索
			handleSearchInput() {
				// 防抖处理
				if (this.searchTimer) {
					clearTimeout(this.searchTimer)
				}

				this.searchTimer = setTimeout(() => {
					if (this.companyName.trim()) {
						this.searchCompanies()
					} else {
						this.companyList = []
					}
				}, 300)
			},

			// 搜索企业
			async searchCompanies() {
				this.loading = true
				try {
					const params = {
						companyName: this.companyName,
						page: 1,
						size: 10
					}

					const { data } = await companyInfoPageList(params)

					if (data.records && data.records.length > 0) {
						this.companyList = data.records
						this.showDropdown = true
						this.loading = false
					} else {
						this.companyList = []
						this.loading = false
					}
				} catch (error) {
					console.error('搜索企业失败', error)
					this.$message.error('搜索企业失败')
					this.loading = false
				}
			},

			// 匹配关键字高亮
			highlightKeyword(text) {
				if (!this.companyName || !text) return text

				const keyword = this.companyName.trim()
				if (!keyword) return text

				// 使用正则表达式进行全局匹配，忽略大小写
				const reg = new RegExp(keyword, 'gi')

				// 将匹配的文本替换为带有红色样式的HTML
				return text.replace(reg, match => `<em>${match}</em>`)
			},

			// 选择企业
			selectCompany(company) {
				this.companyName = company.companyName
				this.selectedCompany = company
				this.showDropdown = false
			},

			// 处理失焦事件
			handleBlur() {
				// 延迟关闭下拉框，以便点击下拉项能够触发
				setTimeout(() => {
					this.showDropdown = false
				}, 200)
			},

			// 处理点击外部
			handleOutsideClick(event) {
				const dropdown = this.$el.querySelector('.search-dropdown')
				if (dropdown && !dropdown.contains(event.target)) {
					this.showDropdown = false
				}
			},

			// 处理认证
			handleConmpanyAuth() {
				if (!this.companyName) {
					this.$message.warning('请输入企业名称')
					return
				}

				console.log('this.selectedCompany:', this.selectedCompany)

				this.$router.push({
					path: '/user/common/company/auth',
					query: {
						companyName: this.selectedCompany?.companyName,
						companyCode: this.selectedCompany?.companyCode
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';

	.company-auth-container {
		background-color: #eff6f9;
		padding: 20px;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

		// 企业信息展示区域样式
		.company-info-section {
			background-color: #fff;
			border-radius: 4px;
			padding: 20px;
			margin-bottom: 20px;

			.section-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 20px;
				padding-bottom: 15px;
				border-bottom: 1px solid #eee;

				.section-title {
					font-size: 16px;
					color: #333;
					margin: 0;
				}

				.auth-status {
					padding: 5px 15px;
					border-radius: 15px;
					font-size: 16px;

					&.status-pending {
						background-color: #e6f7ff;
						color: #1890ff;
					}

					&.status-success {
						background-color: #f6ffed;
						color: #52c41a;
					}

					&.status-failed {
						background-color: #fff2f0;
						color: #f5222d;
					}

					&.status-expired {
						background-color: #f5f5f5;
						color: #999;
					}
				}
			}

			.info-content {
				.info-item {
					display: flex;
					margin-bottom: 15px;

					.info-label {
						width: 160px;
						color: #666;
						font-size: 16px;
					}

					.info-value {
						flex: 1;
						color: #333;
						font-size: 16px;
						font-weight: 500;
					}
				}

				.info-actions {
					margin-top: 25px;
					display: flex;
					justify-content: center;

					.action-button {
						padding: 8px 20px;
						border-radius: 4px;
						font-size: 16px;
						cursor: pointer;
						margin: 0 10px;
						border: 1px solid #dcdfe6;
						background-color: #fff;
						transition: all 0.3s;

						&:hover {
							opacity: 0.8;
						}

						&.primary {
							background-color: #1890ff;
							color: #fff;
							border-color: #1890ff;
						}
					}
				}
			}
		}

		.auth-input-section {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 20px 10px;
			margin-bottom: 20px;
			background-color: #fff;
			border-radius: 4px;

			.input-wrapper {
				flex: 1;
				margin-right: 20px;

				position: relative;

				.search-dropdown {
					position: relative;
					width: 100%;
				}

				.company-input {
					width: 100%;
					height: 40px;
					padding: 0 15px;
					border: 1px solid #dcdfe6;
					border-radius: 4px;
					font-size: 14px;
					color: #606266;
					outline: none;
					transition: border-color 0.2s;

					&:focus {
						border-color: #236fca;
					}

					&::placeholder {
						color: #c0c4cc;
					}
				}

				.dropdown-list {
					position: absolute;
					top: 100%;
					left: 0;
					width: 100%;
					max-height: 200px;
					overflow-y: auto;
					background-color: #fff;
					border: 1px solid #dcdfe6;
					border-radius: 4px;
					box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
					z-index: 10;
					margin-top: 5px;
				}

				.dropdown-item {
					padding: 10px 15px;
					cursor: pointer;
					transition: background-color 0.3s;

					&:hover {
						color: #128bed;
						background-color: #f5f7fa;
					}

					em {
						color: #f56c6c;
						font-weight: bold;
					}
				}

				.dropdown-empty {
					padding: 10px 15px;
					color: #909399;
					text-align: center;
				}
			}

			.auth-button {
				width: 120px;
				height: 40px;
				background-color: #236fca;
				color: #fff;
				border: none;
				border-radius: 4px;
				font-size: 14px;
				cursor: pointer;
				transition: background-color 0.3s;

				&:hover {
					background-color: #236fca;
				}
			}
		}

		.faq-section {
			.moudleDefaultTitle {
				font-size: 18px;
			}

			.faq-content {
				display: flex;
				flex-wrap: wrap;
				margin: 0 -10px;

				.faq-item {
					width: calc(50% - 20px);
					margin: 0 10px 20px;
					padding: 15px;
					background-color: #f9f9f9;
					border-radius: 4px;
					box-sizing: border-box;
					// height: 190px;
					display: flex;
					flex-direction: column;
					box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

					.faq-question {
						font-size: 16px;
						color: #333;
						font-weight: 500;
						margin-bottom: 10px;
						padding-bottom: 10px;
						border-bottom: 1px solid #eee;
					}

					.faq-answer {
						min-height: 150px;
						color: #666;
						font-size: 16px;
						line-height: 1.6;
						flex: 1;
						background-color: #d5eafd;
						border: solid 1px #b7d7ff;
						border-radius: 6px;
						padding: 10px;

						p {
							margin-bottom: 8px;
						}
					}
				}
			}
		}
	}

	.file-preview-list {
		margin-top: 15px;
		border: 1px solid #e6e6e6;
		border-radius: 4px;

		.file-item {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 10px 15px;
			background-color: #f9f9f9;

			.file-info {
				display: flex;
				align-items: center;

				i {
					color: #409eff;
					font-size: 20px;
					margin-right: 8px;
				}

				.file-name {
					color: #333;
					font-size: 14px;
					word-break: break-all;
				}
			}

			.file-actions {
				display: flex;
				align-items: center;

				.el-button {
					margin-left: 10px;
					padding: 0;

					i {
						margin-right: 3px;
					}
				}
			}
		}
	}
</style>
<style>
	/* 当使用scoped属性时，样式只会应用到当前组件的元素上，而不会应用到通过 v-html 动态插入的内容。所以在此再加入一段高亮样式代码 */
	.dropdown-item {
		em {
			color: #f56c6c;
			font-weight: bold;
		}
	}
</style>
